import React, { FC, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import Button from '~/components/atoms/buttons/Button';
import ModalContentText from '~/components/atoms/ModalContentText';
import ModalContentTitle from '~/components/atoms/ModalContentTitle';
import ProductCard from '~/modules/settings/components/ProductCard';
import { ProductType } from '~/types/product';

import styles from './styles.module.scss';

type Props = {
  products: ProductType[];
  onSubmit: (product: ProductType) => void;
};

const ChoosePlan: FC<Props> = ({ products, onSubmit }) => {
  const { t } = useTranslation('modal');
  const [selectedProduct, setSelectedProduct] = useState<ProductType | null>(
    products[0] ?? null,
  );

  useEffect(() => {
    setSelectedProduct(
      (current) =>
        products.find((product) => product.id === current?.id) ??
        products[0] ??
        null,
    );
  }, [products]);

  const handleSubmit = (): void => {
    if (!selectedProduct) {
      return;
    }

    onSubmit(selectedProduct);
  };

  return (
    <div className={styles.container}>
      <ModalContentTitle
        className={styles.title}
        text={t('choose_plan.title', 'Choose a plan to continue')}
      />

      <ModalContentText sx={{ mb: '24px', maxWidth: 'unset' }}>
        {t(
          'choose_plan.text',
          'Your subscription is no longer active. Pick a plan to get your tools back.',
        )}
      </ModalContentText>

      <div className={styles.plans}>
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            isSelectable
            isActive={selectedProduct?.id === product.id}
            orientation="horizontal"
            onProductClick={setSelectedProduct}
          />
        ))}
      </div>

      <Button
        variant="contained"
        color="gradient"
        size="large"
        fullWidth
        disabled={!selectedProduct}
        onClick={handleSubmit}
      >
        {t('general:continue', 'Continue')}
      </Button>
    </div>
  );
};

export default ChoosePlan;
